export default{
    //Apiserveraddress:"https://elearning.waheguruitsol.co.in/",
    Apiserveraddress:"https://speech.learnisl.com/api/",
}
